import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import AshenedCup from './pages/AshenedCup';
import AdminsSupport from './pages/AdminsSupport';
import MadaraPage from './pages/MadaraPage';
import './App.css';

function App() {
  return (
    <Router>
      <div className="app-container">
        <Header />
        <AnimatePresence mode="wait">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/ashened-cup" element={<AshenedCup />} />
            <Route path="/admins-support" element={<AdminsSupport />} />
            <Route path="/madara" element={<MadaraPage />} />
          </Routes>
        </AnimatePresence>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
